<template>
<div v-if="(form?.non_field_errors ?? []).length > 0" class="feedback invalid-feedback d-block">
    <ul class="list-unstyled">
        <li v-for="error, index of form.non_field_errors" :key="index">
            <div class="alert alert-danger" v-html="error"></div>
        </li>
    </ul>
</div>
<div v-if="(form?.non_field_feedback ?? []).length > 0" class="feedback valid-feedback d-block">
    <ul class="list-unstyled">
        <li v-for="msg, index of form.non_field_feedback" :key="index">
            <div class="alert alert-success" v-html="msg"></div>
        </li>
    </ul>
</div>
</template>
<script setup lang="ts">
import { DjangoFormData } from '#src/vue/forms/FormData.mts'

defineProps<{
    form: DjangoFormData
}>()
defineOptions({
    inheritAttrs: false,
})
</script>
